import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { ITaxratesFeature } from './taxrate.feature.state';
import { TaxrateState } from './taxrate.state';

export const getTaxratesState: MemoizedSelector<ITaxratesFeature, TaxrateState> = createFeatureSelector<TaxrateState>(
  nameof<ITaxratesFeature>('taxratesFeature')
);

export const getIsLoading = createSelector(getTaxratesState, (state: TaxrateState) => state.isLoading);
export const getFailures = createSelector(getTaxratesState, (state: TaxrateState) => state.failures);
export const getTaxrates = createSelector(getTaxratesState, (state: TaxrateState) => state.taxrates);
